import { render, staticRenderFns } from "./TourVisit.vue?vue&type=template&id=51ffb40b"
import script from "./TourVisit.vue?vue&type=script&lang=js"
export * from "./TourVisit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports